import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../style/EmpDetail.css";

const EmpDetail = () => {
  const { empId } = useParams(); // get id from route
  const [emp, setEmp] = useState(null);
  const [aptitudeResults, setAptitudeResults] = useState([]);
  const [technicalResults, setTechnicalResults] = useState([]);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch employee details first
      const empRes = await fetch(`https://assessment.tetekniqx.com/api/employees/${empId}/`);
      const empData = await empRes.json();
      setEmp(empData);

      // Fetch aptitude results (static test_name)
      const aptRes = await fetch(
      `https://assessment.tetekniqx.com/api/results/${empId}/${empData.created_at.split("T")[0]}/aptitude`
      );
      const aptData = await aptRes.json();
      setAptitudeResults(aptData);

      // ✅ Now fetch technical results only if topic exists
      if (empData.topic) {
        const techRes = await fetch(
        `https://assessment.tetekniqx.com/api/results/${empId}/${empData.created_at.split("T")[0]}/${empData.topic}`
        );
        const techData = await techRes.json();
        setTechnicalResults(techData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (empId && empId !== 'undefined') {
    fetchData();
  } else {
    setLoading(false);
  }
}, [empId]);


  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }

  if (!emp) {
    return <p style={{ textAlign: "center", color: "red" }}>No candidate data available</p>;
  }

  return (
    <div className="emp-detail__container">
      {/* Page 1: Candidate Details */}
      <h2 className="emp-detail__title">Candidate Details</h2>
      <table className="emp-detail__table">
        <tbody>
          <tr><th>Name</th><td>{emp.name}</td></tr>
          <tr><th>Phone Number</th><td>{emp.number}</td></tr>
          <tr><th>Date of Birth</th><td>{emp.dob}</td></tr>
          <tr><th>Gender</th><td>{emp.gender}</td></tr>
          <tr><th>Marital Status</th><td>{emp.marital_status}</td></tr>
          <tr><th>Nationality</th><td>{emp.nationality}</td></tr>
          <tr><th>Blood Group</th><td>{emp.blood_group}</td></tr>
          <tr><th>Position Applied</th><td>{emp.position_applied}</td></tr>
          <tr><th>Department</th><td>{emp.department}</td></tr>
          <tr><th>Year of Graduation</th><td>{emp.year_of_graduation}</td></tr>
          <tr><th>Current Employer</th><td>{emp.current_employer}</td></tr>
          <tr><th>Total Experience</th><td>{emp.total_experience}</td></tr>
          <tr><th>Relevant Experience</th><td>{emp.relevant_experience}</td></tr>
          <tr><th>Skills</th><td>{emp.skills_certifications}</td></tr>
          <tr><th>Basic Qualification</th><td>{emp.basic_qualification}</td></tr>
          <tr><th>Highest Degree Type</th><td>{emp.highest_degree_type}</td></tr>
          <tr><th>Test Topic</th><td>{emp.topic}</td></tr>
          <tr><th>Aptitude Score</th><td>{emp.score}</td></tr>
          <tr><th>Technical Score</th><td>{emp.tech_score}</td></tr>
          <tr><th>Applied On</th><td>{emp.created_at}</td></tr>
          <tr>
            <th>Download Employee PDF</th>
            <td>
              <a
                href={`https://assessment.tetekniqx.com/api/employees/${emp.id}/download-pdf`}
                className="emp-detail__btn-download"
              >
                Download Employee PDF
              </a>
            </td>
          </tr>
       
          {emp.has_resume_upload && (
            <tr>
              <th>Download Resume</th>
              <td>
                <a
                  href={`https://assessment.tetekniqx.com/api/employees/${emp.id}/resume`}
                  className="emp-detail__btn-download"
                >
                  Download Candidate Resume
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Page 2: Aptitude */}
      <div className="emp-detail__page-break"></div>
      <h2 className="emp-detail__title">Aptitude Test Result</h2>
      <table className="emp-detail__table">
        <thead>
          <tr>
            <th>Q.No</th>
            <th>Question</th>
            <th>Options</th>
            <th>Correct</th>
            <th>Selected</th>
          </tr>
        </thead>
        <tbody>
          {aptitudeResults.length > 0 ? (
            aptitudeResults.map((q, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{q.q1}</td>
                <td>
                  {q.o1}<br />
                  {q.o2}<br />
                  {q.o3}<br />
                  {q.o4}
                </td>
                <td>{q.a1}</td>
                <td>{q.s1}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>No aptitude results available</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Page 3: Technical */}
      <div className="emp-detail__page-break"></div>
      <h2 className="emp-detail__title">{emp.topic ? `${emp.topic} Test Result` : "Technical Test Result"}</h2>
      <table className="emp-detail__table">
        <thead>
          <tr>
            <th>Q.No</th>
            <th>Question</th>
            <th>Options</th>
            <th>Correct</th>
            <th>Selected</th>
          </tr>
        </thead>
        <tbody>
          {technicalResults.length > 0 ? (
            technicalResults.map((q, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{q.q1}</td>
                <td>
                  {q.o1}<br />
                  {q.o2}<br />
                  {q.o3}<br />
                  {q.o4}
                </td>
                <td>{q.a1}</td>
                <td>{q.s1}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>No technical results available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EmpDetail;
